import { markRaw } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { ReservationPage } from '@myorg/booking-lib'
import api from '../../services/api'
import { BookingOrderApi, BookingRequest, API_ENDPOINTS } from '@myorg/type-lib';
import { tzApi } from '../../pages/useUserServices';

/**
 * 建立一個綁定特定 merchantID 的 API 實例
 */
export const createBookingApi = (merchantID: string): BookingOrderApi => ({
  // 實作 getAvailableMatrix (對應你的型別定義)
  getSevenDayMatrix: async (minPpl = 1, maxPpl = 10) => {
    const res = await api().get(API_ENDPOINTS.BOOKING.PUBLIC_MATRIX(merchantID), {
      params: { minPpl, maxPpl }
    })
    return res.data
  },

  createOrder: async (payload: BookingRequest) => {
    const res = await api().post(API_ENDPOINTS.BOOKING.PUBLIC_ORDERS(merchantID), payload)
    return res.data
  }
})

/**
 * 路由配置
 */
export const bookingOrderRoute: RouteRecordRaw = {
  path: "/booking/:merchantID",
  name: "BookingOrder",
  // 使用 markRaw 減少 Vue 響應式追蹤壓力
  component: markRaw(ReservationPage) as any, 
  props: (route) => {
    const mID = route.params.merchantID as string;
    return {
      merchantID: mID,
      // 關鍵：根據當前路由的 ID 建立 API 實作
      bookingApi: createBookingApi(mID),
      tzApi:tzApi,
    };
  }
};